// Event types
import { NetworkTestEntity } from 'root/apps/NetworkHealthTool/services/NetworkHealthToolService';

export const NetworkEventType = {
  NETWORK_TEST_ADDED: 'networkTestAdded',
  NETWORK_TEST_UPDATED: 'networkTestUpdated',
  NETWORK_TEST_RUN_FAILED: 'networkTestRunFailed',
} as const;
export type NetworkEventType = (typeof NetworkEventType)[keyof typeof NetworkEventType];

// Event types data map
export interface NetworkEventDataMap {
  [NetworkEventType.NETWORK_TEST_ADDED]: NetworkTestEntity;
  [NetworkEventType.NETWORK_TEST_UPDATED]: NetworkTestEntity;
  [NetworkEventType.NETWORK_TEST_RUN_FAILED]: null;
}

export const CHANNEL_NAME = 'network-health-tool';
export type ChannelMessage<K extends NetworkEventType = NetworkEventType> = {
  type: K;
  payload: NetworkEventDataMap[K];
};

export const createBroadcastChannel = (): BroadcastChannel => {
  return new BroadcastChannel(CHANNEL_NAME);
};
